module.exports = __webpack_public_path__ + "img/video.6941f360.svg";